<div class="container-fluid py-4">
  <div class="row mb-4 justify-content-center">
    <ng-container *ngFor="let card of resumenCards; index as i">
      <div class="col-3 col-md-2">
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 2 }"
          [routerLink]="card.route"
          [style.cursor]="card.route || i === 2 ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow icon-card"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>

              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 2, 'text-white': i !== 2 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 2 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="i === 3" class="w-100"></div>
    </ng-container>
  </div>
  <div class="row mb-6 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/social']"
          >Social Main</a
        >
        <a
          class="btn btn-dark btn-sm btn-new ms-2"
          [routerLink]="['/observability/social/audits']"
          >Audits & Incidents</a
        >
        <a class="btn btn-dark btn-sm btn-reg ms-2">Executive View</a>
        <a
          class="btn btn-dark btn-sm btn-new ms-2"
          [routerLink]="['/observability/social/leads']"
          >Leads & Community</a
        >
      </div>
    </div>
  </div>
  <br />
  <div class="row mb-4">
    <div class="col-12">
      <div class="health-banner" [ngClass]="healthBadge.badgeClass">
        <div class="d-flex align-items-center w-100">
          <i class="fas fa-heartbeat fa-2x me-3"></i>
          <div>
            <h5
              class="mb-1 fw-bold text-uppercase"
              style="letter-spacing: 0.5px"
            >
              Platform Health: {{ healthBadge.label }}
            </h5>
            <div class="d-flex flex-wrap gap-2 mt-2">
              <span class="badge bg-dark fw-normal">Active Signals:</span>
              <span *ngFor="let signal of activeSignals" class="signal-pill">
                <i class="fas fa-exclamation-triangle me-1"></i>{{ signal }}
              </span>
              <span *ngIf="!activeSignals.length" class="text-muted small"
                >No active signals currently.</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-5">
    <!-- Delivery / Schedule -->
    <div class="col-md-3 mb-3">
      <div
        class="exec-card p-3 shadow-sm bg-white rounded border-top border-4 border-info h-100"
      >
        <h6 class="text-muted fw-bold text-uppercase mb-3">
          <i class="fas fa-calendar-check me-2"></i>Execution Plan
        </h6>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <span class="text-secondary small">Published</span>
          <span class="fs-4 fw-bold text-dark">{{ postsPublished }}</span>
        </div>
        <div class="progress mb-3" style="height: 6px">
          <div
            class="progress-bar bg-info"
            [style.width.%]="
              (postsPublished / (postsPublished + postsScheduled || 1)) * 100
            "
          ></div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <span class="text-secondary small">Scheduled</span>
          <span class="fs-5 fw-bold text-muted">{{ postsScheduled }}</span>
        </div>
      </div>
    </div>

    <!-- Inventory / Content -->
    <div class="col-md-3 mb-3">
      <div
        class="exec-card p-3 shadow-sm bg-white rounded border-top border-4 border-warning h-100"
      >
        <h6 class="text-muted fw-bold text-uppercase mb-3">
          <i class="fas fa-boxes me-2"></i>Asset Inventory
        </h6>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <span class="text-secondary small">Ready for Use</span>
          <span class="fs-4 fw-bold text-success">{{ inventoryReady }}</span>
        </div>
        <div class="progress mb-3" style="height: 6px">
          <div
            class="progress-bar bg-success"
            [style.width.%]="
              (inventoryReady / (inventoryReady + refreshDue || 1)) * 100
            "
          ></div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <span class="text-secondary small">Refresh Due</span>
          <span class="fs-5 fw-bold text-danger">{{ refreshDue }}</span>
        </div>
      </div>
    </div>

    <!-- Quality (Leads) -->
    <div class="col-md-3 mb-3">
      <div
        class="exec-card p-3 shadow-sm bg-white rounded border-top border-4 border-success h-100"
      >
        <h6 class="text-muted fw-bold text-uppercase mb-3">
          <i class="fas fa-star me-2"></i>Lead Quality
        </h6>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <span class="text-secondary small">Valid Leads</span>
          <span class="fs-4 fw-bold text-success">{{
            formatPercent(validLeadRate)
          }}</span>
        </div>
        <div class="progress mb-3" style="height: 6px">
          <div
            class="progress-bar bg-success"
            [style.width.%]="validLeadRate * 100"
          ></div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <span class="text-secondary small">Invalid Leads</span>
          <span class="fs-5 fw-bold text-danger">{{
            formatPercent(invalidLeadRate)
          }}</span>
        </div>
      </div>
    </div>

    <!-- Booking Conversions -->
    <div class="col-md-3 mb-3">
      <div
        class="exec-card p-3 shadow-sm bg-white rounded border-top border-4 border-primary h-100"
      >
        <h6 class="text-muted fw-bold text-uppercase mb-3">
          <i class="fas fa-funnel-dollar me-2"></i>Booking Flow
        </h6>
        <div class="d-flex justify-content-between align-items-center mb-2">
          <span class="text-secondary small">Flow Started</span>
          <span class="fs-4 fw-bold text-primary">{{ bookingStarted }}</span>
        </div>
        <div class="progress mb-3" style="height: 6px">
          <div
            class="progress-bar bg-primary"
            [style.width.%]="(bookingCompleted / (bookingStarted || 1)) * 100"
          ></div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <span class="text-secondary small">Completed</span>
          <span class="fs-5 fw-bold text-success">{{ bookingCompleted }}</span>
        </div>
      </div>
    </div>
  </div>

  <!--  Top 5 Assets by Conversion  -->
  <div class="row">
    <div class="col-12">
      <div class="card shadow-sm border-0 rounded">
        <div class="card-header bg-white border-0 py-3">
          <h6 class="mb-0 text-muted text-uppercase fw-bold">
            <i class="fas fa-trophy text-warning me-2"></i>Top 5 Assets by
            Conversion
          </h6>
        </div>
        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="obs-table mb-0">
              <thead>
                <tr>
                  <th>Platform</th>
                  <th>Post / Asset ID</th>
                  <th>Window</th>
                  <th>Link Clicks</th>
                  <th>DM Starts</th>
                  <th>Avg Engagement</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let asset of topAssets">
                  <td>
                    <span class="badge bg-secondary text-uppercase fw-normal">{{
                      asset.platform
                    }}</span>
                  </td>
                  <td class="fw-bold">{{ asset.platform_post_id }}</td>
                  <td class="text-muted small">{{ asset.window }}</td>
                  <td>
                    <strong class="text-primary">{{
                      asset.link_clicks
                    }}</strong>
                  </td>
                  <td>
                    <strong>{{ asset.dm_starts }}</strong>
                  </td>
                  <td>{{ formatPercent(asset.engagement_rate) }}</td>
                </tr>
                <tr *ngIf="!topAssets.length">
                  <td colspan="6" class="text-center text-muted py-4">
                    No top assets data available.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
